export default __webpack_public_path__ + "static/media/flexbox-1.94ed7486.webp";